import { Injectable, Output, EventEmitter } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { SidebarNavItem, LoggerService } from '@bci-web-core/core';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  public sidebarLinks: SidebarNavItem[] = [];

  constructor(private router: Router) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    // if (Constants.UserManagement != null) { // Check later
    //   return true;
    // }
    this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
    return false;
  }
}
